import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, forwardRef } from 'react';
import classNames from 'classnames';
import Datetime from 'react-datetime';
import noop from 'lodash/fp/noop';
const DEFAULT_LOCALE = 'en-GB';
const DEFAULT_MIN_WIDTH = 0;
const DatePicker = forwardRef((props, ref) => {
    const { id, dropup = false, alignRight = false, locale = DEFAULT_LOCALE, minWidth = DEFAULT_MIN_WIDTH, onChange = noop, mandatory = true, dateValidation, clearableInput = false, closeOnSelect = true, inputProps, className } = props, remainingProp = __rest(props, ["id", "dropup", "alignRight", "locale", "minWidth", "onChange", "mandatory", "dateValidation", "clearableInput", "closeOnSelect", "inputProps", "className"]);
    const [hasError, setHasError] = useState(false);
    const validateDate = (dateToValidate) => {
        // If the entered date complies with the defined dateFormat, the Datetime component
        // returns a moment object, otherwise the return value is a string.
        // Note, using a isValid() function from moment or the Date object itself will result in
        // different outcome in various browsers.
        // For instance `new Date('1')` or `moment('1')` are valid dates in Chrome where it defaults
        // to "01/01/2001" whereas in Firefox it is an invalid date.
        // The solution is to compare the entered value to the date format which is done by React Datetime.
        const isDateObject = typeof dateToValidate === 'object';
        return dateValidation ? dateValidation(dateToValidate) : isDateObject;
    };
    const handleChange = (date) => {
        const isValid = mandatory ? validateDate(date) : true;
        setHasError(!isValid);
        onChange(date, isValid);
    };
    const classes = classNames('DatePicker', 'form-group', hasError && 'has-error', dropup && 'dropup', alignRight && 'align-right', className && className);
    // This way we can expose the "id" as top level prop and not as part of the inputProps which
    // makes the use of the id much more convenient
    const enhancedInputProps = Object.assign({ id }, inputProps);
    return (_jsx(Datetime
    // TODO: add support for setting ref to the input. Maybe add a "inputRef" prop to react-datetime
    // ref={ref}
    , Object.assign({}, remainingProp, { locale: locale, clearableInput: clearableInput, closeOnSelect: closeOnSelect, onChange: handleChange, minWidth: minWidth, inputProps: enhancedInputProps, className: classes })));
});
export default DatePicker;
